import styled from 'styled-components';
export var Actions = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-6ciis3-0"
})(["display:flex;gap:", ";"], function (props) {
  return props.theme.gap(5);
});
export var Action = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-6ciis3-1"
})(["display:flex;align-items:center;gap:", ";color:", ";font-family:'IntervalNextMed',sans-serif;font-size:", ";font-weight:500;line-height:", ";border-radius:8px;transition:opacity 0.5s ease-out;&:hover{cursor:pointer;text-decoration:underline;}", ";"], function (props) {
  return props.theme.gap(2);
}, function (props) {
  return props.theme.photosModal.shareAndWishlist.color;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (_ref) {
  var isLoading = _ref.isLoading;
  return isLoading && "\n      pointer-events: none;\n      opacity: 0.5;\n  ";
});